import React, { useEffect } from "react";

import Footer from "../../Components/Footer/footer.component";
import "./registration.styles.scss";
import SignUp from "../../Components/Sign-up/sign-up.component";
import Header from "../../Components/Header/header.component";
import { Join } from "../../Components/Animation/animation.component";

const Registration = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return (
    <div className="Home">
      <Header />
      <span className="Title">
        SIGN UP TO JOIN OUR COMMUNITY
        <br />
      </span>
      <div className="sign-in">
        <SignUp />
      </div>
      <div
        className="footerSvg"
        style={{
          width: "70vw",
          display: "flex",
          position: "relative",
          top: "40vh",
        }}
      >
        <Join />
      </div>
      <Footer />
    </div>
  );
};
export default Registration;
